export const getImageUrl = (image?: string | File) => {
	if (image instanceof File) {
		return URL.createObjectURL(image as File);
	} else {
		return image;
	}
};
